// extracted by mini-css-extract-plugin
export default {"todoListContainer":"TodoList_todoListContainer__A0CC0","noTodo":"TodoList_noTodo__ahLBw","noTodoIcon":"TodoList_noTodoIcon__vdLuH","todoCounts":"TodoList_todoCounts__MJ52S"};